module.exports = __webpack_public_path__ + "static/img/03.c4d09af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/03.png
// module id = OKjm
// module chunks = 1